import environment from '../../common/environment';
import { AnalyticsEventRequest } from './analytics-proxy.interface';
import { getResponseData } from '../../common/utils/api-utils';

/**
 * Triggers the analytics proxy API call
 *
 * @param requestBody
 */
export async function postAnalyticsEventApiCall(requestBody: AnalyticsEventRequest): Promise<void> {
  const url = new URL(`${environment().magentoUrl}${postAnalyticsProxyMagento()}`);
  return getResponseData(
    new Request(url.toString(), {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(requestBody)
    })
  );
}

export const postAnalyticsProxyMagento = () => `/shop/rest/${environment().checkoutFlow}/V1/proxy-analytics`;
